import React from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Container } from "reactstrap";
import Order from "./Order";

const Orders = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Orders" />
          <Order />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Orders;
